import React from 'react';

import FormikComponent from 'components/Formik';
import {  InputField } from '@cashfree-intl/coherent';

// Constants
import { changeAccountValidationSchema } from '../validation';
import { OB_STATUS as STATUS } from 'constants/enums';

// Types
import { ChangeAccountModalProps } from '../types';

// Styled
import { StyledChangeAccountModal } from '../styled';


const ChangeAccountModal = ({
  onClose,
  onSubmit,
  accountName,
  accountNumberDetails,
  ifsCodeDetails
}: ChangeAccountModalProps) => {
  const initialValues= {
    ifscCode: ifsCodeDetails?.regVal ?? '',
    accountNumber: accountNumberDetails?.regVal ?? '',
    locked:{
      ifscCode: ifsCodeDetails?.locked,
      accountNumber: accountNumberDetails?.locked
    }
  }
  const handleSubmit=(values, actions) => {
    onSubmit(values)
    actions.setSubmitting(false)
  }

  return (
    <FormikComponent 
    initialValues={initialValues}
    validateOnMount
    validationSchema={changeAccountValidationSchema}
    onSubmit={handleSubmit}>
    {({
    values,
    handleFieldBlur,
    handleFieldChange,
    handleSubmit,
    errors,
    touched,
    isValid,
    isValidating,
    isSubmitting
    }) => (
      <StyledChangeAccountModal
        onClose={onClose}
        onConfirm={handleSubmit}
        title="Change Bank Account"
        confirmText="Continue"
        confirmButtonProps={{ 
            disabled: !isValid || (isSubmitting && !isValidating)
        }}
        data-testid="change-account-modal"
      >
        <InputField
          label={`New Bank Account Number ${
            accountName ? `for ${accountName}` : ''
          }`}
          name="accountNumber"
          placeholder="01123456789"
          value={values?.accountNumber}
          onChange={handleFieldChange}
          onBlur={handleFieldBlur}
          errors={errors}
          touched={touched}
          disabled={accountNumberDetails?.locked}
          className={`mt-1 ${            
            accountNumberDetails?.isApproved===STATUS.REJECTED ? 'error_border' : ''
        }`}
        />
        <InputField
          label="IFSC"
          name="ifscCode"
          placeholder="SBIN0001234"
          value={values?.ifscCode}
          onChange={handleFieldChange}
          onBlur={handleFieldBlur}
          errors={errors}
          touched={touched}
          disabled={ifsCodeDetails?.locked}
          className={
            `mt-2 ${accountNumberDetails?.isApproved===STATUS.REJECTED ? 'error_border' : ''}`
          }
        />
      </StyledChangeAccountModal>
    )}
    </FormikComponent>
  );
};

export default ChangeAccountModal;